module.exports = __webpack_public_path__ + "static/balazs-2c19a2f617f1beb51f2a33eabd5f5f29.png";